import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogClose, preventAccidentalDismiss } from "@/components/ui/Modal";
import { Button } from "@/components/ui/Button";
import { ChevronLeft, X } from "lucide-react";
import JobForm from "../component/JobForm";
import { jobFormDefaultValues } from "../validation.schema";

const ManualJobPost = ({ open, onClose, onBack, onSubmit, isSubmitting = false, userOptions }) => {
  return (
    <Dialog open={open} onOpenChange={preventAccidentalDismiss(onClose)}>
      <DialogContent className="h-[90vh] w-[340px] md:w-full flex flex-col">
        {/* HEADER */}
        <DialogHeader className="relative" style={{ zoom: 0.95 }}>
          <div className="pr-20">
            <DialogTitle className="text-xl font-semibold text-text-primary">Manual Posting</DialogTitle>
            <DialogDescription className="text-sm text-text-primary">Enter the required job information to generate a structured job description.</DialogDescription>
          </div>

          <div className="absolute right-7 top-1/2 -translate-y-1/2 flex items-center gap-2">
            {onBack && (
              <Button
                onClick={onBack}
                className="shrink-0 flex items-center gap-1 px-3 py-1.5 rounded-full bg-button-tertiary border border-border-primary text-text-primary text-[13px]"
              >
                <ChevronLeft size={14} /> <span className="hidden md:inline">Back</span>
              </Button>
            )}
            <DialogClose className="w-8 h-8 rounded-full bg-background-icon/40 flex items-center justify-center text-text-primary hover:bg-background-icon/60 transition-colors">
              <X size={16} strokeWidth={3} />
            </DialogClose>
          </div>
        </DialogHeader>

        {/* SCROLLABLE AREA */}
        <div className="flex-1 overflow-y-auto custom-scrollbar">
          {/* BODY */}
          <div className="px-6 py-4" style={{ zoom: 0.95 }}>
            <JobForm onClose={onClose} loadingLabel="Posting..." onSubmit={onSubmit} defaultValues={jobFormDefaultValues} isSubmitting={isSubmitting} userOptions={userOptions} />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ManualJobPost;
